import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=1cb23b3e&scoped=true"
import script from "./Legal.vue?vue&type=script&lang=js"
export * from "./Legal.vue?vue&type=script&lang=js"
import style0 from "./Legal.vue?vue&type=style&index=0&id=1cb23b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb23b3e",
  null
  
)

export default component.exports